import { APIEndpoints } from "../../constants";
import { APIPost, getAuthHeaders, APIResponse } from "../api/common.service";
import {
  CreateAttendanceRequest,
  CreateAttendanceResponseData,
  COQLRequest,
  AttendanceListResponseData,
} from "../../types";

export function CreateAttendance(
  body: CreateAttendanceRequest
): Promise<APIResponse<CreateAttendanceResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<CreateAttendanceResponseData>(
      APIEndpoints.CreateAttendance,
      headers,
      undefined,
      body as unknown as Record<string, unknown>
    )
  );
}

export function SearchAttendance(
  body: COQLRequest
): Promise<APIResponse<AttendanceListResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<AttendanceListResponseData>(
      APIEndpoints.SearchAttendance,
      headers,
      undefined,
      body as unknown as Record<string, unknown>
    )
  );
}
